import * as React from 'react'

/**
 * @description Exchange icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Exchange } from '@sravni/design-system-icons'
 *
 * <Exchange />
 * ```
 */
export const Exchange = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Exchange" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m6.993 3.384-1.241 1.24M5.752 2.143l1.24 1.24M5.339 3.384a2.481 2.481 0 0 0-2.482 2.481M5.339 3.384h1.654M13.61 16.617l1.24-1.241M14.85 17.857l-1.24-1.24M15.264 16.617c1.37 0 2.48-1.11 2.48-2.481M15.264 16.617h-1.655M8.233 16.617a4.562 4.562 0 0 0 4.55-4.55 4.562 4.562 0 0 0-4.55-4.548 4.562 4.562 0 0 0-4.548 4.549c0 1.02.344 1.963.918 2.723a4.54 4.54 0 0 0 3.63 1.826ZM15.585 4.716a4.562 4.562 0 0 1 0 6.433 3.85 3.85 0 0 1-.452.374M15.585 4.716a4.562 4.562 0 0 0-6.433 0c-.14.14-.261.294-.379.448"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
